const restore = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.193%207H10v2H3V2h2v3.27C6.725%203.183%209.196%202%2012%202c5.523%200%2010%204.477%2010%2010s-4.477%2010-10%2010S2%2017.523%202%2012h2a8%208%200%201%200%208-8C9.606%204%207.554%205.079%206.193%207z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  restore as default
};
//# sourceMappingURL=restore.svg.es.js.map
